
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study-sitemap.xml",
      function () {
        return require("private-next-pages/case-study-sitemap.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study-sitemap.xml"])
      });
    }
  